package com.exura.features.legacyplans.data.serialization

import kotlinx.serialization.modules.SerializersModule

val detailedPlanSerializersModule = SerializersModule {
}
